export enum PageRoute {
  LANDING = '/',
  FLEET = '/fleet',
  REJECTIONS = '/fleet/rejections',
  SIRE = '/fleet/sire',
  CDI = '/fleet/cdi',
  ADMIN_SETTINGS = '/admin/settings',
  VERIFY_EMAIL = '/verify-email',
  UNAUTHORIZED = '/unauthorized',
  FEATURE_FLAG = '/feature-flag/*',
  POOL_PARTNERS = 'account-manager/pool-partners',
  ACCOUNT_MANAGER = 'account-manager',
  ERROR_STREAM = 'system-settings/error-stream',
  WELCOME_POPUP = 'system-settings/welcome-popup',
  NOTIFICATION_BANNER = 'system-settings/notification-banner',
  USERS = 'account-manager/users',
  VESSELS = 'fleet',
  FLEET_VESSELS = 'vessels',
  VESSEL = 'vessel/:vesselId/*',
  VESSEL_DASHBOARD = 'vessel-dashboard',
  PARTNER_DASHBOARD = 'partner-dashboard',
  OPS_DASHBOARD = 'ops-dashboard',
  QUESTIONNAIRE = 'questionnaire',
  BASIC_VESSEL_DATA = 'basic-vessel-data',
  VETTING = 'vetting',
  DOCUMENTS = 'documents',
  VOYAGES = 'voyages',
  POOL_POINTS = 'pool-points',
  POSITION_LIST_DECOMMISSIONED = 'position-list',
  CHARTERING = 'chartering',
  SYSTEM_SETTINGS = 'system-settings',
  OPERATIONS = 'operations',
  POSITION_LIST = '/chartering/position-list',
  PROFILE = '/profile',
  MAP = '/chartering/map',
  EXPOSURE = '/chartering/exposure',
  CARGO_LIST = '/chartering/cargo-list',
  CARGO_STATISTICS = '/chartering/cargo-statistics',
  PRE_FIX = '/chartering/pre-fix',
  CLEAR = '/chartering/clear',
  RECAP_HUB = '/chartering/recap-hub',
  EMISSIONS = '/emissions/cii-predictive-tool-insite-digital',
  VESSEL_FINANCIALS = 'financials/vessels/:vessel',
  PORT_INFO = '/port-info',
}
